<template>
    <div class="container">
        <ol class="breadcrumb">
            <li><a v-link="{name: 'home'}">Accueil</a></li>
            <li><a v-link="{name: 'unlinked-contracts'}">Contrats dissociés</a></li>
            <li>#{{ contract.external_id }}</li>
        </ol>

        <div class="heading">
            <div class="f">
                <div class="expand">
                    <h1>
                        <span v-if="contract.id">
                            <strong>#{{ contract.external_id }}</strong>
                        </span>
                    </h1>
                </div>
                <div>
                    <a v-link="{name: 'unlinked-contracts'}"
                       class="btn btn-link">
                        Annuler
                    </a>
                    <button class="btn btn-primary"
                            @click.prevent="save">
                        <loader :inline="true"
                                v-show="saving"></loader>
                        Enregistrer
                    </button>
                </div>
            </div>

            <div class="main">
                <form class="form-container">
                    <div class="form-section">
                        <h3 class="a-h3">Informations contrat</h3>

                        <div class="form-row">
                            <div class="form-group">
                                <div class="input-group">
                                    <label>Versement initial</label>
                                    <div class="value">
                                        {{{ contract.wire_initial | money }}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group">
                                    <label>Versements programmés</label>
                                    <div class="value">
                                        {{{ contract.wire_monthly | money }}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group">
                                    <label>Periodicité de versement</label>
                                    <div class="value">
                                        {{ periodicities[contract.wire_period] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group">
                                <label>Type de projet</label>

                                <select
                                    :disabled="fieldDisabled"
                                    v-model="contract.project_type"
                                    class="form-control"
                                >
                                    <option
                                        v-for="opt of projectTypeSelect"
                                        :key="opt.value"
                                        :value="opt.value"
                                    >{{ opt.label | ucfirst }}</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>Allocation</label>

                                <select
                                    :disabled="fieldDisabled"
                                    v-model="contract.allocation"
                                    class="form-control"
                                >
                                    <option
                                        v-for="opt of allocationSelect"
                                        :key="opt.value"
                                        :value="opt.value"
                                    >{{ opt.label }}</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <div class="dropdown-group">
                                    <label>Cadre fiscale</label>
                                    <div class="value">
                                        {{ getAutomationType }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group">
                                <div class="input-group">
                                    <label for="horizon">Horizon</label>
                                    <input
                                        :disabled="fieldDisabled"
                                        v-model="contract.horizon"
                                        id="horizon"
                                        type="text"
                                        class="form-control"
                                    />
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Sécurité progressive</label>

                                <select
                                    :disabled="fieldDisabled"
                                    v-model="contract.gbi"
                                    class="form-control"
                                >
                                    <option
                                        v-for="opt of gbiSelect"
                                        :key="opt.value"
                                        :value="opt.value"
                                    >{{ opt.label | ucfirst }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="form-section">
                        <h3 class="a-h3">Informations personnelles</h3>

                        <div class="form-row">
                            <div class="form-group">
                                <div class="input-group">
                                    <label>Prénom</label>
                                    <div class="value">
                                        {{ contract.first_name }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group">
                                    <label>Nom</label>
                                    <div class="value">
                                        {{ contract.last_name }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group">
                                    <label for="email">Email du contact</label>
                                    <input
                                        :disabled="fieldDisabled"
                                        v-model="contract.email"
                                        id="email"
                                        type="email"
                                        class="form-control"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group">
                                <div class="dropdown-group">
                                    <label>Nationalité</label>

                                    <select
                                        :disabled="fieldDisabled"
                                        v-model="contract.nationality"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="opt of nationalitiesSelect"
                                            :key="opt.value"
                                            :value="opt.value"
                                        >{{ opt.label }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="dropdown-group">
                                    <label>Résidence fiscal</label>

                                    <select
                                        :disabled="fieldDisabled"
                                        v-model="contract.address_country"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="opt of countriesSelect"
                                            :key="opt.value"
                                            :value="opt.value"
                                        >{{ opt.label | ucfirst }}</option>
                                    </select>

                                    <div
                                        v-if="contract.address_country === 'AUTRE_PAYS'"
                                        class="error"
                                    >
                                        Ce cas de figure n'est pas encore traité
                                        automatiquement.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <div>
                            Envoi à la compagnie
                        </div>
                    </div>
                    <div class="panel-body">
                        <div
                            class="not-sending"
                            v-if="
                                ['NOT_STARTED', 'ERROR'].includes(progress.state)
                                && busy === false
                            "
                        >
                            <button
                                 @click="importData()"
                                class="btn btn-primary"
                            >
                                Importer
                            </button>

                            <div v-if="progress.state === 'ERROR'" class="text">
                                {{ progress.details.message }}
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="progress.state === 'DONE'">
                                <span>
                                    Contrat correctement importé
                                </span>
                                <div class="btn-done">
                                    <a
                                        v-link="{
                                            name: 'contracts-edit',
                                            params: {
                                                id: progress.client,
                                                contractId: progress.contract
                                            }
                                        }"
                                        class="btn btn-primary"
                                    >
                                        Voir le contrat
                                    </a>
                                </div>
                            </div>
                            <span v-else>
                                <loader :inline="true"></loader>
                                <span v-if="progress.state === 'ACTIVESEED_CONTRACT'">
                                    Création du contrat dans ActiveSeed
                                </span>
                                <span v-else>
                                    Veuillez patienter, les données du contrat sont en
                                    cours d'importation - {{ dataImportMessage }}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
@import '~src/style/variables';
.main {
    margin: auto;
    max-width: 850px;

    .form-container {
        margin-top: 48px;

        .form-section {
            margin-bottom: 60px;

            .a-h3 {
                font-size: 30px;
                margin-bottom: 30px;
                margin-top: 18px;
            }

            .form-row {
                display: flex;
                margin-bottom: 20px;

                .form-group {
                    flex: 0 0 33.33%;
                    padding-right: 20px;

                    .error {
                        color: @brand-danger;
                        font-size: 12px;
                        margin: 4px;
                    }
                }
            }
        }
    }

    .panel {

        .panel-body {

            .btn-done {
                margin-top: 20px;
            }

            .not-sending {
                align-items: center;

                .text {
                    background-color: @brand-danger;
                    border-radius: 5px;
                    color: white;
                    font-weight: bold;
                    margin-top: 12px;
                    padding: 6px 10px;
                }
            }
        }
    }
}
</style>

<script type="text/ecmascript-6">
import {
    fetch as fetchContract,
    update,
    importData,
    fetchParameters,
    fetchProgress
} from '../api/unlinked_contracts';
import router from '../router';
import VSelect from 'vue-strap/src/Select';
import {asyncAction} from '../utils';
import {manager as msgManager} from '../messages';
import Loader from '../components/Loader';

export default {
    components: { VSelect, Loader },

    data() {
        return {
            todoPage: 1,
            todoHasNext: false,
            todoLoading: false,

            /**
             * An object with the parameters used to populate the dropdown fields
             * with data coming from the API.
             */
            params: {},

            /**
             * An object used to properly show the periodicities with the data
             * coming from the API.
             */
            periodicities: {
                none: 'Sans périodicité',
                monthly: 'Mensuelle',
                quarterly: 'Trimestrielle',
                biannually: 'Semestrielle',
                annually: 'Annuelle'
            },

            /**
             * The unlinked contract itself.
             */
            contract: {},
            saving: false,

            /**
             * Interval to check the importation progress every second, once
             * process is started.
             */
            progressInterval: null,

            /**
             * Progress object as received from the API to show the correct
             * information in the page. It has a default state of `PENDING` to
             * not show information until data aren't fetched from the API.
             */
            progress: {state: ''},

            /**
             * Together with the progress status, determines if the submit
             * button should be displayed or not.
             */
            busy: false
        };
    },

    computed: {
        /**
         * Maps the `automation_types` params to fit the format required by the
         * `VSelect` component.
         */
        automationTypeSelect() {
            if (this.params.automation_types) {
                return this.params.automation_types.map(t => {
                    return { value: t[0], label: t[1] };
                });
            }
            return null;
        },

        /**
         * Maps the `allocations` params to fit the format required by the
         * `VSelect` component.
         */
        allocationSelect() {
            if (this.params.allocations) {
                return this.params.allocations.map(t => {
                    return { value: t[0], label: t[1] };
                });
            }
            return null;
        },

        /**
         * Maps the `project_types` params to fit the format required by the
         * `VSelect` component.
         */
        projectTypeSelect() {
            if (this.params.project_types) {
                return this.params.project_types.map(t => {
                    return { value: t[0], label: t[1] };
                });
            }
            return null;
        },

        /**
         * Maps the `nationalities` params to fit the format required by the
         * `VSelect` component.
         */
        nationalitiesSelect() {
            if (this.params.nationalities) {
                return this.params.nationalities.map(t => {
                    return { value: t[0], label: t[1] };
                });
            }
            return null;
        },

        /**
         * Maps the `countries` params to fit the format required by the
         * select component.
         */
        countriesSelect() {
            if (this.params.countries) {
                return this.params.countries.map(t => {
                    return { value: t[0], label: t[1] };
                });
            }
            return null;
        },

        /**
         * Object with boolean values for gbi option.
         */
        gbiSelect() {
            return [{ value: true, label: 'Oui' }, { value: false, label: 'Non' }];
        },

        /**
         * Returns readable value for the automation type coming from the API.
         */
        getAutomationType() {
            if (this.params.automation_types) {
                let param = this.params.automation_types.find(a => {
                    return a[0] === this.contract.automation_type;
                })[1];

                if (param === 'Generali Vie') param = 'Assurance Vie';

                return param;
            }
            return null;
        },

        dataImportMessage() {
            if (this.progress.details && this.progress.details.message) {
                return this.progress.details.message.replace(
                    '{imported_days}', this.progress.days_imported
                );
            }
            return null;
        },

        /**
         * Form fields should only be editable in the states in which the form
         * can be submitted.
         */
        fieldDisabled() {
            return !['NOT_STARTED', 'ERROR'].includes(this.progress.state);
        },

        /**
         * Form validation. If form is not valid, data can't be sent.
         */
        formValid() {
            return this.contract.address_country !== 'AUTRE_PAYS';
        }
    },

    route: {
        /**
         * It fetches the unlinked contract with the id provided in the URL. In
         * order to correctly show the initial allocation value, we need to
         * cast it to string.
         *
         * It also fetches the necessary parameters to populate the dropdown
         * fields.
         *
         * By default, `allocation` and `project_type` are not set. So, if they
         * are not present in the db record, the first one of the respective
         * params list is chosen at the beginning.
         */
        data: async function(transition) {
            try {
                const contract = await fetchContract(transition.to.params.id);
                const params = await fetchParameters();
                this.contract = contract;
                this.params = params;

                if (!this.contract.allocation) {
                    this.contract.allocation = params.allocations[0][0];
                }

                if (!this.contract.project_type) {
                    this.contract.project_type = params.project_types[0][0];
                }

                this.progressInterval = setInterval(async () => {
                    this.progress = await fetchProgress(contract.progress);
                    if (this.progress.state === 'DONE') {
                        this.stopInterval();
                    }
                }, 1000);

                return { contract, params };
            } catch (e) {
                router.replace({ name: 'not-found' });
            }
        }
    },

    beforeDestroy() {
        this.stopInterval();
    },

    methods: {
        save: asyncAction('saving', async function () {
            await update(this.contract);
            msgManager.push('Succès.', 'Data correctly updated.', 'success');
        }),

        stopInterval() {
            clearInterval(this.progressInterval);
            this.progressInterval = null;
        },

        /**
         * Starts the importation process and checks it status every second.
         * When button is clicked, a new progress object is created in the
         * database, so the interval should re-start.
         */
        async importData() {
            if (this.formValid) {
                this.busy = true;
                await update(this.contract);
                const res = await importData(this.contract.external_id);

                this.stopInterval();
                this.progressInterval = setInterval(async () => {
                    this.progress = await fetchProgress(res.progress_id);
                    if (this.progress.state === 'DONE') {
                        this.stopInterval();
                    }
                    this.busy = false;
                }, 1000);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// UnlinkedContractsDetail.vue?2391d8e3